/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
export class Accident{
  accidentId: number;
  fakeAccidentTime:string;
  accidentTime: string;
  accidentDate: string;
  accidentid: number;
  attachment: string;
  accidentClassificationId: number;
  classification: string;
  accidentCausationId: number;
  causation: string;
  siteId:number;
  siteName:String;
  locationTypeId:number;
  locationTypeName:string;
  locationId: number;
  locationName: string;
  subLocation: string;
  accidentCommentId: number;
  comment: string
}
